import { useMutation, useQuery } from "react-query";
import Api, { ImgAPI } from "../../apiclient/api";

import { UpdateRF } from "./ApiHandler";
// Reusable function for handling auth response
const handleAuth = async (data, customer, setCustomer, rf, navigate) => {
    if (data?.status === "Expire") {
        setCustomer?.({});
        await UpdateRF(rf);
        navigate('/login')
        return null;
    }else{
        if(data?.authorization){
            setCustomer((prev) => ({
                ...prev,
                token: {
                ...prev?.token,
                authorization: data?.authorization,
                },
            }));
        }
    }

    if (data?.authorization && customer) {
        setCustomer(prev => ({
            ...prev,
            token: {
                ...prev.token,
                authorization: data.authorization,
            },
        }));
    }

    return data;
};

// GET request hook
export const useGetRequest = (endpoint, queryKey, headers = {}, extras = {}, params = {}) => {
    const { customer, setCustomer, rf, navigate } = extras;
    return useQuery({
        queryKey: [queryKey, params], // All changing parameters must be here
        queryFn: async () => {
            try {
                const response = await Api.get(endpoint, { headers, params });
                return handleAuth(response.data,  customer, setCustomer, rf, navigate );
            } catch (err) {
                console.error(`GET ${endpoint}`, err);
                throw err;
            }
        },
        enabled: Boolean(endpoint),
        // Important configuration options: 
        keepPreviousData: true, // Smooth transitions between queries
        staleTime: 30 * 1000, // Data stays fresh for 30 seconds
        refetchOnWindowFocus: true, // Standard best practice
    });

};

// POST request hook
export const usePostRequest = (endpoint, imgApi = false, headers = {}, extras = {}) => {
    const { customer, setCustomer, rf, navigate } = extras;

    return useMutation(
        async (payload) => {
            if (!endpoint) {
                return ;
            }
            const api = imgApi ? ImgAPI : Api;
            const response = await api.post(endpoint, payload, headers);
            return await handleAuth(response.data, customer, setCustomer, rf, navigate);
        }
    );
};